export default function FacebookDataDeletion() {
  return (
    <div style={{ fontFamily: 'sans-serif', maxWidth: 600, margin: '60px auto', padding: '0 20px' }}>
      <h2>Data Deletion Instructions</h2>
      <p>
        If you logged in using Facebook and want your data deleted from our app, please email us at{' '}
        <strong>bqtexpress@gmail.com</strong> with the subject{' '}
        <strong>"Facebook Data Deletion Request."</strong>
      </p>
      <p>Include the Facebook name or email used to log in.</p>
      <p>
        We will delete your account data from our system within a reasonable timeframe and confirm once completed.
      </p>
    </div>
  );
}
